import type { ParentProps } from 'solid-js'
import { Grid } from 'styled-system/jsx'
import Root from './root'

function Container(props: ParentProps) {
  return <>
    {props.children}
  </>
}

const routes = [
  {
    path: '/notifications',
    component: Container,
    children: [
      {
        path: '/',
        component: Root,
      },
    ],
  },
]

export default routes
